var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmartPhone = function SvgSmartPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "smart-phone_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".smart-phone_svg__st0{fill:none;stroke:#000;stroke-width:2;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smart-phone_svg__Smart_Phone"
  }, /*#__PURE__*/React.createElement("path", {
    className: "smart-phone_svg__st0",
    d: "M15 1h18c2.2 0 4 1.8 4 4v38c0 2.2-1.8 4-4 4H15c-2.2 0-4-1.8-4-4V5c0-2.2 1.8-4 4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 43,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "smart-phone_svg__st0",
    d: "M11 39h26"
  }))));
};
export default SvgSmartPhone;